import type { SVGProps } from 'react';

interface PredictionIconProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
export const PredictionIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & PredictionIconProps) => (
  <svg
    {...props}
    aria-labelledby={titleId}
    fill="none"
    height="1em"
    role="img"
    viewBox="0 0 48 48"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id={titleId}>{title}</title>
    <g clipPath="url(#prediction_svg__a)">
      <ellipse
        cx={24}
        cy={24.27}
        rx={16}
        ry={16.18}
        stroke="#fff"
        strokeWidth={2}
      />
      <path
        d="M0 22.034a1 1 0 0 1 1-1h9.25a1 1 0 0 1 .71.297l2.211 2.236a1 1 0 0 1 0 1.406l-2.21 2.236a1 1 0 0 1-.712.297H1a1 1 0 0 1-1-1zM48 22.034a1 1 0 0 0-1-1h-9.25a1 1 0 0 0-.71.297l-2.211 2.236a1 1 0 0 0 0 1.406l2.21 2.236a1 1 0 0 0 .712.297H47a1 1 0 0 0 1-1zM21.8 0a1 1 0 0 0-1 1v9.376a1 1 0 0 0 .29.703l2.2 2.224a1 1 0 0 0 1.422 0l2.2-2.224a1 1 0 0 0 .289-.703V1a1 1 0 0 0-1-1zM26.2 48a1 1 0 0 0 1-1v-9.376a1 1 0 0 0-.29-.703l-2.2-2.224a1 1 0 0 0-1.422 0l-2.2 2.224a1 1 0 0 0-.289.703V47a1 1 0 0 0 1 1z"
        fill="#B0CEFC"
      />
      <path
        d="M18.133 27.236v0c-.589 0-1.067-.478-1.067-1.067V21.83c0-.589.478-1.066 1.067-1.066v0M20.534 18.337v0c0-.596.483-1.079 1.078-1.079h4.243c.596 0 1.079.483 1.079 1.079v0M29.332 20.764v0c.589 0 1.066.477 1.066 1.067v4.338c0 .59-.477 1.067-1.066 1.067v0M26.931 29.663v0c0 .595-.483 1.078-1.078 1.078H21.61a1.08 1.08 0 0 1-1.079-1.078v0"
        stroke="#4FA9FF"
        strokeLinecap="round"
        strokeWidth={1.5}
      />
    </g>
    <defs>
      <clipPath id="prediction_svg__a">
        <path d="M0 0h48v48H0z" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);
